<template>
  <div style="overflow: scroll">
    <div class="base-info">
      {{ hospitalInfo.hospitalName }}
      <div @click="showPicker = true" class="inspection-name">
        <div class="van-ellipsis" style="width: 90%;">
          {{ currentItem.title }}
        </div>
        <van-icon name="arrow-down" color="white" />
      </div>
      <div style="display: flex;">
        <span>{{ userInfo.patientName }} {{ userInfo.cardNo }}</span>
        <span style="margin-left: auto;">{{
          date.replace(/(.{2})(.{2})/, "$1月$2日")
        }}</span>
      </div>
    </div>
    <div
      v-for="(item, index) in inspectionDetailList"
      :key="index"
      class="item-list"
    >
      <div
        :class="[
          item.departure == 1 ? 'item-value-up' : '',
          item.departure == -1 ? 'item-value-down' : ''
        ]"
      >
        {{ item.name }}
        <span>
          {{ item.value }}
          <span
            v-if="item.departure == 1"
            style="margin-left: 6px;font-size: 1rem"
            >↑</span
          >
          <span
            v-if="item.departure == -1"
            style="margin-left: 6px;font-size: 1rem"
            >↓</span
          >
        </span>
      </div>
      <div style="display: flex;font-size: .94rem;">
        <div style="width: 65%;">检测项目</div>
      </div>
    </div>
    <div class="describe">
      <div>影像描述</div>
      <div>{{ describe }}</div>
    </div>
    <div class="describe">
      <div>小结</div>
      <div>{{ conclusion }}</div>
    </div>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        :columns="getReportList"
        @cancel="showPicker = false"
        @confirm="onConfirm"
        show-toolbar
      />
    </van-popup>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      inspectionDetailList: [],
      query: {},
      currentItem: {},
      list: [],
      userInfo: {},
      showPicker: false,
      date: "",
      describe: "",
      conclusion: "",
      hospitalInfo: {}
    };
  },
  computed: {
    ...mapState({
      hospitalInfo: state => state.home.hospitalInfo
    }),
    getReportList() {
      return this.list.map(item => {
        return {
          text: item.title,
          ...item
        };
      });
    }
  },
  created() {
    const { currentItem, list, date, ftype } = this.$route.query;
    this.currentItem = currentItem;
    this.list = list;
    this.date = date;
    this.getInspectionsDetail(currentItem);
    this.getUserBaseInfo(ftype).then(res => {
      this.userInfo = res;
    });
  },
  methods: {
    ...mapActions("users", ["getUserBaseInfo"]),
    onConfirm(item) {
      this.showPicker = false;
      this.currentItem = item;
      this.getInspectionsDetail(item);
    },
    getInspectionsDetail(param) {
      this.$http
        .post(this.$api.REPORT_INSPECTION_DETAIL, {
          reportSerialNo: param.id,
          inspectionType: param.inspectionType
        })
        .then(res => {
          this.describe = res[0].describe;
          this.conclusion = res[0].conclusion;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.base-info {
  padding: 10px;
  color: white;
  background: @primary-blue;
}
.inspection-name {
  display: flex;
  margin: 4px 0;
  color: white;
  span {
    font-size: 0.94rem;
  }
}
.describe {
  margin: 12px;
  padding-bottom: 12px;
  border-bottom: solid 0.67px #dcdcdc;

  div {
    margin: 5px;
    line-height: 1.5rem;
  }
}
.item-list {
  margin: 12px;
  padding-bottom: 12px;
  border-bottom: solid 0.67px #dcdcdc;

  div {
    line-height: 1.5rem;
  }

  span {
    float: right;
    color: #959595;
    font-size: 0.88rem;
  }
}

.item-value-up {
  color: red;

  span {
    color: red;
  }
}

.item-value-down {
  color: blue;

  span {
    color: blue;
  }
}
</style>
